enum ResourceTypeDisplay {
  microLesson = "Microlessons",
  skillTutor = "Targeted Tutoring",
  tutor = "Tutoring",
  teacherResource = "Teacher Resources",
  istationLegacyActivity = "Digital Instruction by Istation",
  textSet = "Text Sets",
  ERSS = "Skill Scaffolds",
  EPS = "Tutoring",
}

export function getUniqueResourceProperties(resources: any[]) {
  const uniqueActivityTypes = new Set<keyof typeof ResourceTypeDisplay>();
  const uniqueProviders = new Set<string>();

  resources.forEach(resource => {
    if (resource.resourceType && resource.resourceType in ResourceTypeDisplay) {
      uniqueActivityTypes.add(resource.resourceType as keyof typeof ResourceTypeDisplay);
    }
    if (resource.provider) {
      uniqueProviders.add(resource.provider);
    }
  });

  return {
    activityTypes: Array.from(uniqueActivityTypes).map(type => ({
      label: ResourceTypeDisplay[type],
      value: type
    })),
    providers: Array.from(uniqueProviders).map(provider => ({
      label: provider,
      value: provider
    }))
  };
}